import React, { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import { AspectOptimization } from "@pages/CROModule/components/Product/Optimisation/components/DefaultOptimization/Aspects";
import { SpiderService } from "@services/spider/spider.services";
import { useProductStore } from "src/store/overviewProduct.state";
import { useIsMobile } from "src/utils/isMobile";
import { AspectsService } from "@services/amazon/aspects/aspects.service";
import {
  AspectsStatsMock,
  AspectReviewsMock,
  AspectImproveMock,
  ProductProblemsMock,
} from "./mock";
import { SpiderChart } from "./components/SpiderChart";
import { ProblemsSolution } from "./components/ProblemsSolution";
import { AspectInsight } from "./components/AspectInsight";
import { StatsType } from "./components/SpiderChart/types";
import { AspectImprove } from "./components/AspectImprove";

interface ProblemsBlockProps {
  topProblems?: Problem[];
  intelligence?: boolean;
}

interface Problem {
  title: string;
  description: string;
}

const ProblemsBlock: React.FC<ProblemsBlockProps> = ({
  topProblems,
  intelligence,
}) => {
  const [selectedProblem, setSelectedProblem] = useState<Problem | null>(null);
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null);
  const [spiderDots, setSpiderDots] = useState([]);
  const [isTooltipVisible, setIsTooltipVisible] = useState(false);
  const [isDragEnabled, setIsDragEnabled] = useState(false);
  const [activeProblemIndex, setActiveProblemIndex] = useState(0);
  const [problems, setProblems] = useState([]);
  const { selectedProduct } = useProductStore();
  const isMobile = useIsMobile();

  const [aspectsStats, setAspectsStats] = useState(AspectsStatsMock.items);
  const [aspectReviews, setAspectReviews] = useState(AspectReviewsMock.items);
  const [reviewDetails, setReviewDetails] = useState(null);
  const [productProblems, setProductProblems] = useState(
    ProductProblemsMock.items,
  );
  const [aspectImprove, setAspectImprove] = useState(AspectImproveMock);

  const [activeIndex, setActiveIndex] = useState(0);
  const [currentAspectData, setCurrentAspectData] = useState<StatsType | null>(
    null,
  );

  useEffect(() => {
    if (aspectsStats && aspectsStats.length > 0) {
      setCurrentAspectData(aspectsStats[activeIndex]);
    }
  }, [activeIndex, aspectsStats]);

  const handleProblemClick = (problem: Problem, index: number) => {
    if (selectedProblem?.title === problem.title) {
      setSelectedProblem(null);
      setSelectedIndex(null);
    } else {
      setSelectedProblem(problem);
      setSelectedIndex(index);
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLDivElement>,
    problem: Problem,
    index: number,
  ) => {
    if (e.key === "Enter" || e.key === " ") {
      handleProblemClick(problem, index);
    }
  };
  const handlePredictionInsightClick = () => {
    if (!isDragEnabled) {
      setIsTooltipVisible(true);
    } else {
      setIsTooltipVisible(false);
    }
    setIsDragEnabled(!isDragEnabled);
  };
  const handleProductSelect = async () => {
    const spider = new SpiderService();
    const spiderDotsResponse = await spider.getProfuctInfo(selectedProduct);

    setSpiderDots(Array.isArray(spiderDotsResponse) ? spiderDotsResponse : []);
    setProblems(Array.isArray(spiderDotsResponse) ? spiderDotsResponse : []);
  };

  useEffect(() => {
    handleProductSelect();
  }, []);

  const fetchAspectsStats = async () => {
    try {
      const aspectsService = new AspectsService();
      const response = await aspectsService.fetchAspectsStats(
        "AMAZON",
        selectedProduct,
        0,
        10,
      );
      setAspectsStats(
        response && response.items && response.items.length > 0
          ? response.items
          : AspectsStatsMock.items,
      );
    } catch (error) {
      console.error("Error fetching aspects stats:", error);
    }
  };

  const fetchAspectReviews = async (aspect: string) => {
    try {
      const aspectsService = new AspectsService();
      const response = await aspectsService.fetchAspectReviews(
        "AMAZON",
        JSON.stringify(selectedProduct),
        aspect,
        0,
        10,
      );
      setAspectReviews(
        response && response.length > 0 ? response : AspectReviewsMock.items,
      );
    } catch (error) {
      console.error("Error fetching aspect reviews:", error);
    }
  };

  const fetchReviewDetails = async (reviewId: string) => {
    try {
      const aspectsService = new AspectsService();
      const response = await aspectsService.fetchReviewDetails(reviewId);
      setReviewDetails(response);
    } catch (error) {
      console.error("Error fetching review details:", error);
    }
  };

  const fetchProductProblems = async () => {
    try {
      const aspectsService = new AspectsService();
      const response = await aspectsService.fetchProductProblems(
        "AMAZON",
        JSON.stringify(selectedProduct),
        0,
        10,
      );
      setProductProblems(
        response && response.items.length > 0
          ? response.items
          : ProductProblemsMock.items,
      );
    } catch (error) {
      console.error("Error fetching product problems:", error);
    }
  };

  useEffect(() => {
    if (selectedProduct) {
      fetchAspectsStats();
      fetchProductProblems();
    }
  }, [selectedProduct]);

  return (
    <div className={styles.expandedContainer}>
      <div className={styles.expandedContent}>
        {/* <h3>Opportunities</h3> */}
        <div className={styles.comparisonBetween}>
          {isMobile && (
            <div className={styles.aspects}>
              {aspectsStats.length > 0 ? (
                <AspectOptimization
                  AspectsStats={aspectsStats}
                  AspectsReviews={aspectReviews}
                  isWhatIf={true}
                />
              ) : (
                <div className={styles.emptyBlock}>empty</div>
              )}
            </div>
          )}
          {/* <div className={styles.comparison}>
            <ProblemSolution
              problems={productProblems}
              onPredictionInsightClick={handlePredictionInsightClick}
              activeProblemIndex={activeProblemIndex}
            />
          </div>
          {!isMobile && (
            <div className={styles.aspects}>
              {aspectsStats.length > 0 ? (
                <AspectOptimization
                  isWhatIf={true}
                  AspectsStats={aspectsStats}
                  AspectsReviews={aspectReviews}
                />
              ) : (
                <div className={styles.emptyBlock}>empty</div>
              )}
            </div>
          )} */}

          <div className={styles.col}>
            <SpiderChart
              AspectsStats={aspectsStats}
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
            />
            {!intelligence && (
              <ProblemsSolution
                type="problem"
                productProblems={productProblems}
                activeIndex={activeIndex}
              />
            )}
          </div>
          <div className={styles.col}>
            <AspectInsight
              activeIndex={activeIndex}
              setActiveIndex={setActiveIndex}
              currentAspectData={currentAspectData}
              AspectsReviews={aspectReviews}
            />
            <AspectImprove
              aspectImprove={aspectImprove}
              activeIndex={activeIndex}
            />
            {!intelligence && (
              <ProblemsSolution
                type="solution"
                productProblems={productProblems}
                activeIndex={activeIndex}
              />
            )}
          </div>
        </div>
        {/* {selectedProblem && (
          <div className={styles.problemMoreInfo}>
            <ProblemDetails problem={selectedProblem} />
          </div>
        )} */}
      </div>
    </div>
  );
};

export default ProblemsBlock;
